import angular from 'angular';
import MarkCompletedPreApprovalModal from './markCompletedPreApprovalModal';

export default angular
  .module('components.markCompletedPreApprovalModal', [])
  .component('markCompletedPreApprovalModal', MarkCompletedPreApprovalModal)
  .name;
